import { render } from "./WorkplaceTms.vue?vue&type=template&id=d28d4e82&scoped=true&ts=true"
import script from "./WorkplaceTms.vue?vue&type=script&lang=ts"
export * from "./WorkplaceTms.vue?vue&type=script&lang=ts"

import "./WorkplaceTms.vue?vue&type=style&index=0&id=d28d4e82&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d28d4e82"]])

export default __exports__